'use client';

import { __assign } from '../_virtual/_tslib.js';
import React__default from 'react';
import { Container, TextareaCss } from './index.css.js';
import Typography from '../Typography/index.js';
import { colors } from '../Colors/index.js';

function Textarea(props) {
    var children = props.children, label = props.label, _a = props.hasError, hasError = _a === void 0 ? false : _a, onChange = props.onChange, value = props.value;
    var handleChange = function (e) {
        var _a, _b;
        onChange && onChange((_b = (_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '');
    };
    return (React__default.createElement(Container, null,
        label && (React__default.createElement(Typography, { variant: 'label', typoName: 'label', typoSize: 'medium', color: colors.grey[20] }, label)),
        React__default.createElement(TextareaCss, __assign({}, props, { hasError: hasError, value: value, onChange: handleChange }), children)));
}

export { Textarea as default };
//# sourceMappingURL=index.js.map
